import React, { Fragment, memo, type FC } from "react";

export type NutritionMacroTableColumnProps = {
  isLoading?: boolean;
  name?: string;
  primaryValue: number;
  primaryUnit: string;
  secondaryValue?: number;
  secondaryUnit?: string;
};

export const NutritionMacroTableColumn: FC<NutritionMacroTableColumnProps> =
  memo(
    ({
      isLoading,
      name,
      primaryValue,
      primaryUnit,
      secondaryValue,
      secondaryUnit,
    }) => {
      return (
        <div className="border border-gray-200 rounded-md p-6 flex flex-col w-44">
          {isLoading ? (
            <div className="bg-gray-300 animate-pulse h-4 w-3/4" />
          ) : (
            <dt className="h-4 text-base font-normal text-gray-900">{name}</dt>
          )}
          <dd className="h-8 flex items-end justify-between md:block lg:flex gap-2">
            {isLoading ? (
              <div className="h-6 bg-gray-300 w-full animate-pulse"></div>
            ) : (
              <div className="h-6 flex items-baseline text-2xl font-semibold text-primary-600">
                {primaryValue.toFixed(0)}
              </div>
            )}

            {isLoading ? (
              <div className="h-4 bg-gray-300 w-6 animate-pulse" />
            ) : (
              <div className="h-4 text-gray-500">{primaryUnit}</div>
            )}
          </dd>
          <dd className="h-8 flex items-end justify-between md:block lg:flex gap-2">
            {secondaryUnit && (
              <Fragment>
                {isLoading ? (
                  <div className="h-6 bg-gray-300 w-full animate-pulse"></div>
                ) : (
                  <div className="h-6 flex items-baseline text-2xl font-semibold text-primary-600">
                    {secondaryValue.toFixed(2)}
                  </div>
                )}

                {isLoading ? (
                  <div className="h-4 bg-gray-300 w-6 animate-pulse" />
                ) : (
                  <div className="h-4 text-gray-500">{secondaryUnit}</div>
                )}
              </Fragment>
            )}
          </dd>
        </div>
      );
    }
  );
